import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/college-student-shipping.jpg'),
    alt: 'college student shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college student shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'College Student <span>Shipping</span> <span>With ShipAndStorage</span>',
  description:
    'ShipAndStorage makes shipping for college students simple, affordable, and reliable. Whether you’re going to campus or need extra storage, we have tailored solutions to save you time & money.',
  image: {
    url: '/images/v2/pages/main-pages/college-student-shipping/hero-image.jpg',
    alt: 'snowboard-shipping'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Start Shipping' }
}

export const whyWeSectionContent = {
  title: 'How It Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Ship Without Hassle' },

  cards: [
    {
      id: 1,
      title: 'Book Your Shipment',
      description: 'Sign up online, enter your details, and get an instant quote.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/book-your-shipment.svg',
        alt: 'Book Your Shipment service'
      }
    },
    {
      id: 2,
      title: 'Prepare Your Items',
      description: 'Pack your belongings securely and attach the labels we send via email.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/prepare-your-items.svg',
        alt: 'Prepare Your Items service'
      }
    },
    {
      id: 3,
      title: 'Ship Your Items',
      description: 'Choose doorstep pickup or drop-off at a carrier location near you.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/ship-your-items.svg',
        alt: 'Ship Your Items service'
      }
    },
    {
      id: 4,
      title: 'Receive Your Shipment',
      description: 'Relax while we deliver your belongings on time and in excellent condition.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/receive-your-shipment.svg',
        alt: 'Receive Your Shipment service'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Ship with ShipAndStorage?',
  description: 'ShipAndStorage is trusted by thousands of students for our superior services.',

  cards: [
    {
      id: 1,
      title: 'Affordable Shipping Solutions',
      description:
        'Save up to 70% on shipping costs compared to traditional carriers. Our transparent pricing ensures no hidden fees, making our services budget-friendly.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/affordable-shipping-solutions.svg',
        alt: 'Affordable Shipping Solutions service'
      }
    },
    {
      id: 2,
      title: 'Convenient and Flexible Options',
      description:
        'Choose between doorstep pickup or drop-off at a nearby carrier location. Our flexible solutions work around your schedule, providing maximum convenience.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/convenient-and-flexible-options.svg',
        alt: 'Convenient and Flexible Options service'
      }
    },
    {
      id: 3,
      title: 'Reliable and Secure Delivery',
      description:
        'We prioritize the safety of your belongings with real-time tracking, free insurance coverage up to $250, and additional insurance options for valuable items.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/reliable-and-secure-delivery.svg',
        alt: 'Reliable and Secure Delivery service'
      }
    },
    {
      id: 4,
      title: 'Free and Secure Storage',
      description:
        "Enjoy six months of free storage in our state-of-the-art, climate-controlled facilities. When you're ready, we’ll deliver your items directly to you.",
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/free-and-secure-storage.svg',
        alt: 'Free and Secure Storage service'
      }
    },
    {
      id: 5,
      title: 'User-Friendly Booking System',
      description:
        'Our online platform is designed to simplify the entire shipping process, making it incredibly easy for users to book and manage their shipments.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/user-friendly-booking-system.svg',
        alt: 'User-Friendly Booking System service'
      }
    },
    {
      id: 6,
      title: '24/7 Customer Support',
      description:
        'Have questions or need assistance? Our dedicated support team is available 24/7 to guide you through every step of your shipping and storage process.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/customer-support.svg',
        alt: '24/7 Customer Support service'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Items Not Covered by Insurance',
  description: 'Our shipments include insurance coverage up to $250.',

  cards: [
    {
      id: 1,
      title: 'Fragile Goods',
      description: 'Items like glassware and ceramics are not covered for damage.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/fragile-goods.svg',
        alt: 'Fragile Goods service'
      }
    },
    {
      id: 2,
      title: 'Valuables',
      description: 'Jewelry, antiques, collectibles, and precious metals are excluded.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/valuables.svg',
        alt: 'Valuables service'
      }
    },
    {
      id: 3,
      title: 'Electronics',
      description: 'Devices and camera equipment are not covered under standard insurance.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/electronics.svg',
        alt: 'Electronics service'
      }
    },
    {
      id: 4,
      title: 'Cosmetic Wear',
      description: 'Scratches, dents, or other minor cosmetic damage to luggage and bags are excluded.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/cosmetic-wear.svg',
        alt: 'Cosmetic Wear service'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Prohibited Items',
  description: 'Certain items are restricted for safety and compliance.',

  cards: [
    {
      id: 1,
      title: 'Pressurized Containers',
      description:
        'Free up space at home by storing seasonal items, extra furniture, or other belongings you don’t need daily.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/pressurized-containers.svg',
        alt: 'Pressurized Containers service'
      }
    },
    {
      id: 2,
      title: 'Alcohol Products',
      description:
        'Shipping these items is not permitted due to specific regulatory restrictions that govern their transportation. ',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/alcohol-products.svg',
        alt: 'Alcohol Products service'
      }
    },
    {
      id: 3,
      title: 'Perishable Foods',
      description: 'Items like produce and dairy are not allowed as they could spoil during transit.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/perishable-foods.svg',
        alt: 'Perishable Foods service'
      }
    },
    {
      id: 4,
      title: 'Batteries',
      description:
        'Lithium batteries, whether standalone or included in devices are restricted to prevent fire hazards.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/batteries.svg',
        alt: 'Batteries service'
      }
    },
    {
      id: 5,
      title: 'Medication Supplements',
      description:
        'Prescription drugs, over-the-counter medication, and vitamins are restricted due to regulatory concerns.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/medication-supplements.svg',
        alt: 'Medication Supplements service'
      }
    },
    {
      id: 6,
      title: 'Valuables & Currency',
      description:
        'Items such as cash, coins, and precious metals are prohibited to avoid loss or theft during shipping.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/valuables-currency.svg',
        alt: 'Valuables & Currency service'
      }
    }
  ]
}

export const SchoolPickUpAndDeliverySectionContent = {
  title: 'School Pick-up and Delivery Instructions',
  description: 'Shipping to or from a school campus is straightforward with these tips.',

  cards: [
    {
      id: 1,
      title: 'Verify School Policies',
      description:
        "Check your school's shipping regulations and ensure couriers are permitted to access dormitories or mailrooms.",
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/verify-school-policies.svg',
        alt: 'Verify School Policies service'
      }
    },
    {
      id: 2,
      title: 'Provide Accurate Details',
      description:
        'Include complete address details, such as dormitory name and mailroom address, on your order & shipping labels.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/provide-accurate-details.svg',
        alt: 'Provide Accurate Details service'
      }
    },
    {
      id: 3,
      title: 'Schedule Smartly',
      description:
        'Match your pick-up and delivery windows with the operating hours of your school’s mailroom or lobby.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/schedule-smartly.svg',
        alt: 'Schedule Smartly service'
      }
    },
    {
      id: 4,
      title: 'Coordinate with Campus Staff',
      description:
        'Inform mailroom staff about your shipment and provide tracking information to streamline the process.',
      image: {
        src: '/images/v2/pages/main-pages/college-student-shipping/coordinate-with-campus-staff.svg',
        alt: 'Coordinate with Campus Staff service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ready to Ship?',
  description:
    'Take the stress out of moving and storing your belongings. With ShipAndStorage, you can travel light and focus on your studies. Book Now and experience the convenience of seamless shipping and storage solutions!',
  image: {
    src: '/images/v2/pages/main-pages/college-student-shipping/promotional-banner-image.png',
    alt: 'Ready to Ship?'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Your Shipment' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What items can I ship with ShipAndStorage?',
      answer:
        'You can ship luggage, boxes, sports equipment, and more. Just avoid restricted items like aerosols, alcohol, and batteries.'
    },
    {
      id: 2,
      question: 'Can I ship internationally?',
      answer: 'Yes! We provide affordable and reliable shipping to over 220 countries.'
    },
    {
      id: 3,
      question: 'What if my shipment is delayed?',
      answer: 'Delays are rare, but our 24/7 support team will assist you in resolving any issues promptly.'
    },
    {
      id: 4,
      question: 'Can I extend the free storage period?',
      answer: 'Yes, you can extend your storage period at a nominal cost.'
    },
    {
      id: 5,
      question: 'Is insurance available for high-value items?',
      answer: 'Yes, you can purchase additional coverage for items exceeding the $250 free insurance limit.'
    },
    {
      id: 6,
      question: 'What happens if I pack prohibited items?',
      answer:
        'Prohibited items will result in shipment delays or cancellations. Review our restricted items list before packing.'
    }
  ]
}
